export default __webpack_public_path__ + "static/3-kit-img-d0805efef6008ff037bd3f60923a7502.png";